module.exports = __webpack_public_path__ + "static/media/gitlab.a28dd005.svg";